/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  // DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  // Button,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const AssignedTrayBarcodeTablePopup = ({ open, onClose, rows }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        style={{
          padding: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontWeight: "bold", color: "#3f51b5" }} // Primary color
          >
            Tray Barcode List
          </Typography>
          <IconButton
            onClick={onClose}
            style={{
              color: "red", // Red color for the close icon
              padding: "4px", // Small size
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent
        style={{
          paddingTop: 0,
          paddingLeft: 5,
          paddingRight: 5,
          paddingBottom: 24,
        }}
        dividers
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Tray Barcode</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>
                Assigned Job ID
              </TableCell>
              <TableCell style={{ fontWeight: "bold" }}>Assigned On</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows && rows.length > 0 ? (
              rows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.trayBarcodeLabel}</TableCell>
                  <TableCell
                    style={{
                      color: `${row.isAssigned == 1 ? "red" : "green"}`,
                    }}
                  >
                    {row.isAssigned == 1 ? "Assigned" : "Available"}
                  </TableCell>
                  <TableCell>
                    {(row.isAssigned == 1 && row.assignedOrderId) || "-"}
                  </TableCell>
                  <TableCell>
                    {(row.isAssigned == 1 && row.assignedOn) || "-"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <>
                {" "}
                <TableCell
                  colSpan={4}
                  style={{
                    textAlign: "center",
                  }}
                >
                  No Data Found
                </TableCell>
              </>
            )}
          </TableBody>
        </Table>
      </DialogContent>
      {/* <DialogActions>
        <Button
          size="small"
          onClick={onClose}
          color="primary"
          variant="outlined"
        >
          Close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

AssignedTrayBarcodeTablePopup.propTypes = {
  values: PropTypes.object,
  onClose: PropTypes.func,
  rows: PropTypes.array,
  open: PropTypes.bool,
};

AssignedTrayBarcodeTablePopup.defaultProps = {
  values: {},
  onClose: (fn) => fn,
  rows: [],
  open: false,
};

export default AssignedTrayBarcodeTablePopup;
